import React, { useEffect, useState } from "react";
import
  {
    Card,
    CardHeader,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
  } from "reactstrap";
import { ServicesDetailDataApp } from "../../../common/data";
import Loader from "../../../Components/Common/Loader";
import { ServicesApp } from "./DashboardEcommerceCharts";

const ServicesDetail = ( { periode } ) =>
{
  const [ servicesDetailsData, setServicesDetailsData ] = useState( [] );

  const fetchData = async () =>
  {
    const getServicesDetailsData = await ServicesDetailDataApp( periode );
    setServicesDetailsData( getServicesDetailsData );
  };

  useEffect( () =>
  {
    fetchData();
  }, [ periode ] );

  return (
    <React.Fragment>
      { servicesDetailsData.length > 0 ? (
        servicesDetailsData.map( ( item, key ) => (
          <Col xl={ 3 } md={ 6 } key={ key }>
            <Card className="card-height-100">
              <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">{ item.title }</h4>
                {/* <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown" direction='start'>
                                        <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                                            <span className="text-muted">Report<i className="mdi mdi-chevron-down ms-1"></i></span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem>Download Report</DropdownItem>
                                            <DropdownItem>Export</DropdownItem>
                                            <DropdownItem>Import</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div> */}
              </CardHeader>

              <div className="card-body">
                <div dir="ltr">
                  <ServicesApp
                    label={ item.label }
                    data={ item.data }
                    dataColors={ item.color }
                  />
                </div>
              </div>
            </Card>
          </Col>
        ) )
      ) : (
        <>
          <Col xl={ 12 }>
            <Card className="h-100 w-100">
              <div className="text-center my-3">
                <Loader style={ { color: "#014c94" } } />
                <h2>Chargement...</h2>
              </div>
            </Card>
          </Col>
        </>
      ) }
    </React.Fragment>
  );
};

export default ServicesDetail;
